<template>
  <Modal title="推送结果" width="720" v-model="state" :closable="false" :mask-closable="false" class-name="vertical-center-modal">
    <div class="c-content">
      <Table :max-height="320" :columns="tableColumns" :data="tableData"> </Table>
    </div>
    <template slot="footer">
      <div class="m-foot">
        <Button @click="$emit('on-close')">知道了</Button>
      </div>
    </template>
  </Modal>
</template>
<script>
// import { isArray } from '@/common/js/utils'
export default {
  name: 'resultDialog',
  props: {
    value: {
      type: Boolean
    },
    failTotal: {
      type: Number
    },
    addTotal: {
      type: Number
    },
    updateTotal: {
      type: Number
    },
    type: {
      type: String
    },
    req: {
      type: String
    },
    downFail: {
      type: Boolean
    },
    tableData: {
      type: Array
    },
    tableColumns: {
      type: Array,
      default() {
        return [
          {
            key: 'dmpName',
            title: '人群包',
            width: 200
          },
          {
            key: 'pushResult',
            title: '结果'
          },
          {
            key: 'failMsg',
            title: '失败原因',
            width: 300
          }
        ]
      }
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-content {
  width: 100%;
  min-height: 100px;

  h3 {
    line-height: 40px;
  }
}
</style>
